import { defineComponent as _defineComponent } from 'vue'
import { AssertByTypename } from '@/helpers/graphql-model-helper';
import pictureCompHelper from '@/helpers/picture-comp-helper';
import { ClickGuideItemLink } from '@/pages/editorial/tracking';
import { GuideEntryFragment } from '@/pages/graphql/queries/GetGuideArticles.query';
import { computed } from 'vue';
import AuthorBox from '@/components/editorial/AuthorBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideItem',
  props: {
    item: null,
    index: { default: 0 },
    clamp: { default: 0 },
    showParagraph: { type: Boolean, default: true },
    variant: { default: 'standard' },
    h4Heading: { type: Boolean, default: false }
  },
  emits: ["content-clicked"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'content-clicked', { label, property }: ClickGuideItemLink): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { item: GuideEntryFragment, index: number, clamp: number, showParagraph: boolean, variant: 'featured' | 'standard' | 'list', h4Heading: boolean };





const itemTitle = computed(() => {
	// the content is an HTML string so this slices out the <h1> tags
	if (props.item.content.title == null) return '';
	return props.item.content.title.replace(/<\/?[^>]+(>|$)/g, '');
});
const mainObject = computed(() => {
	type Node = GuideEntryFragment['mainObjects'][number]['node'];
	type MainObject = AssertByTypename<Node, 'GenericTitleList' | 'Movie' | 'Show' | 'Season'>;
	return props.item.mainObjects[0]?.node as MainObject;
});
const backdrop = computed(() => {
	if (!!mainImageEntityBackdrop.value) return `${JW_CONFIG.IMAGESCALER_URL}${mainImageEntityBackdrop.value}`;

	if (!mainObject.value) return null;

	let backdropUrl: string | null = null;

	if (
		(mainObject.value.__typename === 'GenericTitleList' &&
			(mainObject.value.titles.edges ?? [])[0]?.node.content.backdrops[props.index]) ||
		(mainObject.value.__typename !== 'GenericTitleList' && mainObject.value.content.backdrops[props.index])
	) {
		backdropUrl =
			mainObject.value.__typename === 'GenericTitleList'
				? (mainObject.value.titles.edges ?? [])[0]?.node.content.backdrops[props.index]?.backdropUrl
				: mainObject.value.content.backdrops[props.index]?.backdropUrl;
	} else {
		backdropUrl =
			mainObject.value.__typename === 'GenericTitleList'
				? (mainObject.value.titles.edges ?? [])[0]?.node.content.backdrops[0]?.backdropUrl
				: mainObject.value.content.backdrops[0]?.backdropUrl;
	}

	if (!backdropUrl) return null;

	const profile = props.variant === 'featured' ? 'backdrop' : 'article_backdrop';
	return pictureCompHelper.getDefaultImageUrl(backdropUrl, profile, '', false);
});
const mainImageEntityBackdrop = computed(() => {
	return !!props.item?.content?.mainImageEntityBackdrop?.backdropUrl
		? props.item.content.mainImageEntityBackdrop.backdropUrl
		: '';
});

// TRACKING
function trackClick(e: Event) {
	const target = e.target as HTMLElement;
	if (target.nodeName !== 'A') return;

	const label = (target as HTMLAnchorElement).href;
	const property = mainObject.value.__typename === 'GenericTitleList' ? 'editorial-list' : 'news';
	emit('content-clicked', { label, property, value: props.index } as const);
}

return { __sfc: true,props, emit, itemTitle, mainObject, backdrop, mainImageEntityBackdrop, trackClick, AuthorBox }
}

})